import {TweenLite} from 'gsap';
import gsap from 'gsap';
import {ScrollToPlugin} from 'gsap/all';

gsap.registerPlugin(ScrollToPlugin);

export function escapeHtml(text) {
  let map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  return `${text}`.replace(/[&<>"'`=\/]/g, (char) => map[char]);
}

export function createElementFromHtml(html) {
  let $div = document.createElement('div');

  $div.innerHTML = html;

  return $div.children[0];
}

export function normalizeIndex(index, length) {
  return ((index % length) + length) % length;
}

export function range(from, to) {
  let result = [];

  for (let i = from; i <= to; i++) {
    result.push(i);
  }

  return result;
}

export function animatedScrollTo({
  x = window.pageXOffset,
  y = window.pageYOffset,
  minDuration = 0.3,
  maxDuration = 1
}) {
  return new Promise((resolve) => {
    let dx = Math.abs(window.pageXOffset - x);
    let dy = Math.abs(window.pageYOffset - y);
    let distance = Math.sqrt(dx * dx + dy * dy);
    let duration = Math.min(Math.max(minDuration, distance / 1000), maxDuration);

    TweenLite.to(window, duration, {
      scrollTo: {
        x,
        y
      },
      onComplete() {
        resolve();
      }
    });
  });
}

export function chunkArray(array, chunkSize) {
  chunkSize = Math.max(1, chunkSize);

  let chunks = [];

  for (let i = 0, j = array.length; i < j; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }

  return chunks;
}

export function formatNumber(
  number,
  {thousandsSeparator = '', commaSeparator = '.', fractionDigits = null} = {}
) {
  if (fractionDigits !== null) {
    number = number.toFixed(fractionDigits);
  } else {
    number = number.toString();
  }

  number = number.split('.');

  let sign = '';

  if (number[0][0] === '-') {
    sign = '-';
    number[0] = number[0].slice(1);
  }

  number[0] = chunkArray(number[0].split('').reverse(), 3)
    .map((x) => x.reverse().join(''))
    .reverse()
    .join(thousandsSeparator);

  number = number.join(commaSeparator);

  return sign + number;
}

export function disableScroll() {
  document.body.classList.add('no-scroll');
  document.body.style.paddingRight = `${window.innerWidth - document.body.scrollWidth}px`;
}

export function enableScroll() {
  document.body.classList.remove('no-scroll');
  document.body.style.paddingRight = '0px';
}

export function isIE() {
  return document.body.classList.contains('is-browser-ie');
}

export function triggerWindowResize() {
  let resizeEvent;

  if (isIE()) {
    resizeEvent = document.createEvent('UIEvents');
    resizeEvent.initUIEvent('resize', true, false, window, 0);
  } else {
    resizeEvent = new Event('resize');
  }

  window.dispatchEvent(resizeEvent);
}

export function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options = {}) {
  options = {
    path: '/',
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  if (!isNaN(options.expires)) {
    options.expires = new Date(options.expires).toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey;

    let optionValue = options[optionKey];

    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function getServerLink(endpoint) {
  const origin =
    window.location.hostname == 'localhost'
      ? 'https://kronshtadt.labab.ru'
      : window.location.origin;

  return origin + endpoint;
}

const DEVICES = {
  DESKTOP: {
    BREAKPOINT: 1280,
    ID: 1
  },
  MOBILE: {
    ID: 0
  }
};

function getCurrentDevice() {
  if (window.innerWidth <= DEVICES.DESKTOP.BREAKPOINT) {
    return DEVICES.MOBILE.ID;
  }
}

export function isMobile() {
  return getCurrentDevice() === DEVICES.MOBILE.ID;
}
